import React from "react";
import { SanityUnitOfWork } from "../../model/lessons";
import GetText from "../../i18n/GetText";
import {
  ArticleCardFields,
  CardInternalLink,
  SanityCardList
} from "../../model/common";
import ArticleCard from "../ArticleCard/ArticleCard";
import CardTrio from "../CardTrio/CardTrio";
import GenericCard from "../GenericCard/GenericCard";
import { BreakpointValues } from "../Image/Image";
import Text from "../Text/Text";
import styles from "./CardList.module.scss";

const textForType = (d: ArticleCardFields) => {
  switch (d._type) {
    case "dybWinners":
      return "do your :bit";
    case "globalGoalsResource":
      return "Global goals resource";
    case "make":
      return "Make it: code it";
    case "newsArticle":
      return "News";
    case "pdCourse":
      return "Professional development";
    case "unitOfWork":
      return (
        <GetText
          key="unitType"
          id={`unitType-${(d as SanityUnitOfWork).unitType}`}
        />
      );
    default:
      return undefined;
  }
};

interface CardListProps {
  node: SanityCardList;
  widths?: BreakpointValues;
}

const CardList = ({
  node: { items, layout, readMore },
  widths
}: CardListProps) => {
  return (
    <CardTrio layout={layout}>
      {items.map(item => {
        if (item._type === "cardInternalLink") {
          const mixedType =
            Array.from(
              new Set(
                items.map(item => (item as CardInternalLink).reference?._type)
              )
            ).filter(Boolean).length > 1;
          const titleBefore = textForType(item.reference);
          return (
            <ArticleCard
              key={item._key}
              article={item.reference}
              readMore={readMore}
              className={mixedType ? styles.card : undefined}
              widths={widths}
              titleBefore={
                mixedType &&
                titleBefore && (
                  <Text variant="defaultTiny" className={styles.cardType}>
                    {titleBefore}
                  </Text>
                )
              }
            />
          );
        }
        return (
          <GenericCard
            key={item._key}
            layout={layout}
            card={item}
            readMore={readMore}
          />
        );
      })}
    </CardTrio>
  );
};

export default CardList;
